export const ROUTE_HOME = '/';
export const ROUTE_PURCHASER = '/purchases';
export const ROUTE_SELLER = '/sales';
export const ROUTE_USERPROFILE = '/auth/profile';
export const ROUTE_CALENDAR = '/calendar';
export const ROUTE_SHOPPINGCAR = '/shoppingcart';
export const ROUTE_404 = '/404-not-found';
export const ROUTE_LOGIN = '/login';
export const ROUTE_SIGNUP = '/sign-up';
export const ROUTE_CREATESERVICE = '/create-service';
export const ROUTE_ACTIVATE = '/activate/:hash';
export const ROUTE_SERVICEDETAIL = '/detail/:id';
export const ROUTE_CHECKOUT = '/checkout';
export const ROUTE_EDITSERVICE = '/edit-service/:id';
export const ROUTE_EDITUSER = '/edit-user/:id';
export const ROUTE_CHAT = '/chat/:id';
